import { FC } from 'react';
import { ProductCarousal } from '@commerce-webcomponents/ui-composite';
import { Logger } from '@nextgen-web-framework/core';
import logObject from '../../../logObject';
import type { FeatureProductProps } from './types/propTypes';
import styles from './FeatureProduct.module.scss';

const FeatureProduct: FC<FeatureProductProps> = ({
  featureProductIds,
  isReceiver,
}: FeatureProductProps): React.JSX.Element => {
  const logger = Logger.getInstance(logObject('FeatureProduct'));
  const products = featureProductIds.map((p) => ({
    productId: p,
    isBundle: false,
  }));
  try {
    return (
      <div data-testid="feature-product-testid" className={styles['feature-product-container']}>
        <ProductCarousal
          products={products}
          title={''}
          pageName=""
          aprContainerKey=""
          type={'vertical'}
          backgroundColor=""
          componentType=""
          showAddToCartButtonComp={isReceiver ? true : false}
          showVariantComp={false}
          showProductIdAndSizeComp={false}
          showAddToWishlistComp={false}
        />
      </div>
    );
  } catch (error) {
    logger.error('FeatureProduct', error);
    return (
      <div data-testid="feature-product-error-testid" className={styles['feature-product-container']}>
        Error: FeatureProduct
      </div>
    );
  }
};

export default FeatureProduct;
